import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import { alpha } from '@mui/material/styles'

import { Text } from '@mxenabled/mxui'

import type { ImageBlockData } from '../../../core/types/InsightsInstanceSlotData'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

import type { BlockProps } from '../types'

const INSIGHTS_ASSETS_URL = 'https://content.moneydesktop.com/storage/MD_Assets/md/insights'

const imageMap: Record<string, string> = {
  cashBack: `${INSIGHTS_ASSETS_URL}/CashBack.png`,
}

const ImageBlock = ({ payload }: BlockProps<ImageBlockData>) => {
  const { amount, image } = payload.instance_slot_data
  return (
    <Stack
      justifyContent="flex-end"
      sx={{
        background: `url(${imageMap[image]}) no-repeat top / cover`,
        height: 175,
        width: '100%',
      }}
    >
      <Box
        sx={{
          bgcolor: (theme) => alpha(theme.palette.success.light, 0.6),
          height: 56,
          p: 8,
          pl: 16,
        }}
      >
        <Text color="success.dark" variant="h1">
          {formatCurrency(amount, '0,0.00')}
        </Text>
      </Box>
    </Stack>
  )
}

export default ImageBlock
